import { StyleSheet } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  titleContainerStyle: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 16,
    paddingHorizontal: 16,
  },
  titleTextStyle: {
    fontSize: 16,
    ...Fonts.type.bold,
  },
  selectAllTextStyle: {
    fontSize: 14,
  },
  selectAllDimmedTextStyle: {
    opacity: 0.38,
  },
  showBtnStyle: {
    fontSize: 16,
  },
  showMoreContainer: {
    paddingTop: 16,
  },
  showBtnContainerStyle: {
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 16,
  },
  marginStyle: {
    paddingTop: 16,
  },
  dividerStyle: theme => ({
    marginHorizontal: 16,
    backgroundColor: theme.colors.borderColorFour,
    height: 1,
    marginBottom: 24,
  }),
  emptyViewStyle: theme => ({
    flexDirection: 'row',
    alignItems: 'center',
    borderBottomWidth: 1,
    borderBottomColor: theme.colors.divider,
    paddingBottom: 17,
    marginLeft: 16,
  }),
  emptyTextStyle: {
    fontSize: 14,
    lineHeight: 18,
    marginLeft: 18.53,
    marginRight: 16,
    flex: 1,
  },
  primaryButtonStyle: { marginTop: 8 },
  secondaryButtonStyle: { marginTop: 16 },
  btnContainerStyle: { marginHorizontal: 16 },
});
